
// Reusable formatter function for use in non-JSX contexts (tooltips, formatter functions)
export const formatNumber = (value, locale = 'french', decimals = 1) => {
    if (value == null || isNaN(value)) return '—';

    const localeMap = {
        french: 'fr-FR',
        english: 'en-US',
        portuguais: 'pt-PT',
        swahili: 'sw-SW',
    };

    const resolvedLocale = localeMap[locale] || 'fr-FR';

    return new Intl.NumberFormat(resolvedLocale, {
        minimumFractionDigits: 0,
        maximumFractionDigits: decimals,
    }).format(value);
};

// Default React component wrapper (keeps existing usage intact)
const FormattedNumber = ({ value, locale = 'french', decimals = 2 }) => {
    const formatted = formatNumber(value, locale, decimals);
    return <>{formatted}</>;
};

export default FormattedNumber;
